<template>
    <div class="Man-Rfi-Principal">
        <PageTitle icon="fa fa-bus" main="Relação de carros em manutenção"
            sub="Lançamentos" />
        <div class="Man-Rfi-Principal">
            <b-card no-body>
                <b-tabs>                    
                    <b-tab title="Lançamentos" active><ManutencaoRfiLancamento /></b-tab>                                                                                                                        
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import ManutencaoRfiLancamento from '../man_rfi/ManutencaoRfiLancamento'
export default {
    name: 'ManutencaoRfiPrincipal',    
    components: { PageTitle, ManutencaoRfiLancamento}
    
}
</script>

<style>

</style>






